<template>
    <v-container fluid grid-list-sm>
        <v-layout>
            <v-flex>
                <h1 class="display-2">Gestión de etiquetas</h1>
                <br>
                <v-layout row wrap>
                    <v-flex xs4>
                        <empresa-select v-model="form.empresa_id"></empresa-select>
                    </v-flex>

                </v-layout>
                <v-container fluid grid-list-sm>
                    <v-layout row wrap>
                        <v-flex xs6>
                            <v-alert info :value="true">
                                <div>
                                    <h3>ARMADO DEL ARCHIVO EXCEL A IMPORTAR</h3>
                                    <p>A fin de que pueda conformar el archivo para importación de etiquetas, la estructura de las columnas que debe seguir es la siguiente:
                                        <b>ID DEL PRODUCTO | LOTE | CANT DE ETIQUETAS | COD NUMERICO | Nº DE OP</b>.</p>
                                    <p>
                                        Respecto de la columna <b>COD NUMERICO</b>, sirve para indicar cuando el codigo del producto es inteligente (ej: MCCC5TPB5TU10) o es numerico (ej: 1300.00402). Siempre que sea código numérico
                                        se debe indicar con la <b>LETRA "N"</b>. Esto permite cambiar en el excel, el punto "." al codigo numérico por cualquier otro valor (ej: 1300-00402 ó 1300,00402) o simplemente omitirlo (ej: 130000402).
                                        Pero <b>SIEMPRE RESPETANDO LA CANTIDAD DE CARACTERES</b>. Esto es solamente necesario cuando el código es numérico.
                                    </p>
                                    <p>En caso de que el producto no posea lote dejar el campo vacío, pero siempre respetando la columna para cada valor</p>

                                </div>
                            </v-alert>
                            <div ref="drop" class="dropzone text-center text--black"></div>
                            <v-progress-linear v-model="progreso.porcent" :active="loading"></v-progress-linear>
                        </v-flex>
                        <v-flex xs6>
                            <h4>Etiquetas cargadas {{ etiquetas.length }}</h4>
                            <div class="list-wrap">
                                <v-list two-line>
                                    <template v-for="(e,k) in etiquetas">
                                        <v-list-tile :key="k" @click="">
                                            <v-list-tile-content>
                                                <v-list-tile-title>Producto {{ e.producto_id }}</v-list-tile-title>
                                                <v-list-tile-sub-title>Cantidad {{ e.cant }}</v-list-tile-sub-title>
                                            </v-list-tile-content>
                                        </v-list-tile>
                                        <v-divider></v-divider>
                                    </template>
                                </v-list>
                            </div>
                        </v-flex>
                    </v-layout>
                </v-container>
                <br>
                <v-layout row>
                    <v-flex xs4>
                        <v-autocomplete
                                :items="impresoras"
                                v-model="form.impresora"
                                label="Impresora"
                                item-text="text"
                                item-value="ip"
                        ></v-autocomplete>
                    </v-flex>
                    <v-flex>
                        <v-btn dark default @click.native="imprimir()">Imprimir
                            <v-icon right>print</v-icon>
                        </v-btn>
                    </v-flex>
                </v-layout>
                <errores v-model="msj.mostrar" :datos="msj"></errores>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import Dropzone from 'dropzone'
    import 'dropzone/dist/dropzone.css'
    import {mapGetters} from 'vuex'
    import empresaSelect from '../../components/EmpresaSelect'
    import errores from '../../components/Errores'

    export default {
        components: {empresaSelect, errores},
        data() {
            return {
                dropzone: {},
                dropUrl: 'api/stock/etiquetas/importar',
                msj: {
                    mostrar: false,
                    txt: '',
                    tipo: '',
                    errores: false
                },
                loading: false,
                progreso: {
                    porcent: 0,
                    msj: ''
                },
                empresas: [],
                impresoras: [
                    {text: 'ACEROLATINA', ip: '192.168.11.59'}, 
                    {text: 'ACEROLATINA 2', ip: '192.168.243.208'},
                    {text: 'ACEROLATINA 3', ip: '192.168.243.207'},
                    {text: 'BERVILL', ip: '192.168.210.61'},
                    {text: 'FRIOLATINA', ip: '192.168.1.118'},
                    {text: 'LOGISTICA', ip: '192.168.2.205'},
                    {text: 'TEJATECH', ip: '192.168.1.102'},
                    {text: 'Friolatina L3L5', ip: '192.168.11.96'},
                    {text: 'Bervill D2', ip: '192.168.210.16'},
                    {text: 'METALURGICA', ip: '192.168.243.206'},
                ],
                form: {
                    empresa_id: '',
                    impresora: ''
                },
                etiquetas: []
            }
        },
        mounted() {
            let self = this;
            // window.Echo.private('progreso')
            //     .listen('.progreso', e => {
            //         self.loading = true;
            //         self.progreso = e;
            //         if (self.progreso.porcent === 100) {
            //             self.loading = false;
            //             self.progreso.porcent = 0;
            //         }
            //     });

            Dropzone.autoDiscover = false;
            this.dropzone = new Dropzone(this.$refs.drop, {
                url: this.dropUrl,
                params: this.form,
                headers: {'Authorization': 'Bearer ' + this.$ls.get('token')},
                dictDefaultMessage: "Arrastre aqui los arhivos a subir o haga click",
                init() {
                    this.on('success', r => {
                        let response = JSON.parse(r.xhr.response);
                        if (response.err) {
                            self.msj = {
                                mostrar: true,
                                txt: 'Errores de importación',
                                tipo: 'error',
                                errores: response.listado
                            }
                        } else {
                            self.listado();
                        }
                    })
                }
            });
            this.listado();
        },
        methods: {
            imprimir() {
                if (!this.form.empresa_id || !this.form.impresora) {
                    this.msj = {mostrar: true, txt: 'Debe elegir impresora y empresa', tipo: 'error'}
                    return false;
                }
                this.$http.post('stock/etiquetas/imprimir', this.form)
                    .then(r => {
                        this.result = r.data
                        this.msje = true
                    }, err => {
                        this.msj = {mostrar: true, txt: 'Error de conexión', tipo: 'error'}
                    })
            },
            listado() {
                this.$http.post('stock/etiquetas/listado')
                    .then(r => {
                        this.etiquetas = r.data
                    }, err => {
                        this.msj = {mostrar: true, txt: 'Error de conexión', tipo: 'error'}
                    })
            }
        }
    }
</script>
<style>
    .list-wrap {
        max-height: 300px;
        overflow-y: auto;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/stock/etiquetas.vue